import { addDays, format } from 'date-fns';
import { handleActions } from 'redux-actions';

import { EMPTY_VALUES } from 'constants/general';

import * as types from './actionTypes';
import { quickFilter } from './constants';

export const initialState = {
	leads: EMPTY_VALUES.ARRAY,
	customSort: '',
	availableLeads: EMPTY_VALUES.ARRAY,
	quickFilter: quickFilter.CURRENT,
	selectedNextDay: format(addDays(new Date(), 1), 'yyyy-MM-dd'),
	inProgressAndAfterDeadlineLeadOverview: EMPTY_VALUES.ARRAY,
	inProgressAndAfterDeadlineLeads: {},
	searchedWithCustomFilter: false,
	selectedInProgressTaskTypeId: null,
	onDetailThroughMarketPlaceRow: false,
};

const reducerMap = {
	[types.RESET]: () => initialState,
	[types.SET_SORT_VALUE]: (state, { payload }) => {
		const { sortValue } = payload;
		return {
			...state,
			customSort: sortValue,
		};
	},
	[types.SET_LEADS]: (state, { payload }) => {
		const { leads } = payload;
		return {
			...state,
			leads,
		};
	},
	[types.APPEND_LEADS]: (state, { payload }) => {
		const { leads } = payload;
		return {
			...state,
			leads: [...state.leads, ...leads],
		};
	},
	[types.RESET_LEADS]: (state) => {
		return {
			...state,
			leads: EMPTY_VALUES.ARRAY,
		};
	},
	[types.CHANGE_QUICK_FILTER]: (state, { payload }) => {
		const { type } = payload;
		return {
			...state,
			quickFilter: type,
		};
	},
	[types.CHANGE_SELECTED_DAY_OF_NEXT_DAYS]: (state, { payload }) => {
		const { selectedNextDay } = payload;
		return {
			...state,
			selectedNextDay,
		};
	},
	[types.SET_AVAILABLE_LEADS]: (state, { payload }) => {
		const { competitionAvailableLeads } = payload;
		return {
			...state,
			availableLeads: competitionAvailableLeads,
		};
	},
	[types.SET_INPROGRESS_AND_DEADLINE_LEAD_OVERVIEW]: (state, { payload }) => {
		const { inProgressAndAfterDeadlineLeadOverview } = payload;
		return {
			...state,
			inProgressAndAfterDeadlineLeadOverview,
		};
	},
	[types.SET_INPROGRESS_LEADS_BY_TYPE]: (state, { payload }) => {
		const { taskTypeId, leads } = payload;
		return {
			...state,
			inProgressAndAfterDeadlineLeads: {
				...state.inProgressAndAfterDeadlineLeads,
				[taskTypeId]: leads,
			},
		};
	},
	[types.APPEND_INPROGRESS_LEADS_BY_TYPE]: (state, { payload }) => {
		const { taskTypeId, leads } = payload;
		return {
			...state,
			inProgressAndAfterDeadlineLeads: {
				...state.inProgressAndAfterDeadlineLeads,
				[taskTypeId]: [...state.inProgressAndAfterDeadlineLeads[taskTypeId], ...leads],
			},
		};
	},
	[types.SET_SELECTED_INPROGRESS_TASKTYPEID]: (state, { payload }) => {
		const { taskTypeId } = payload;
		return {
			...state,
			selectedInProgressTaskTypeId: taskTypeId,
		};
	},
	[types.SET_SEARCHED_WITH_CUSTOM_FILTER]: (state, { payload }) => {
		const { value } = payload;
		return {
			...state,
			searchedWithCustomFilter: value,
		};
	},
	[types.SET_ON_DETAIL_THROUGH_MARKETPLACE_ROW]: (state, { payload }) => {
		const { value } = payload;
		return {
			...state,
			onDetailThroughMarketPlaceRow: value,
		};
	},
};

export default handleActions(reducerMap, initialState);
